(function () {

    "use strict";

    angular
        .module('components')
        .component('hFileChooserComponent', {
            controller: HFileChooserComponent,
            controllerAs: 'hFileChooserComponent',
            bindings: {
                viewOnly: '<',
                data: '<',
                class: '@',
                disabled: '<'
            },
            templateUrl: '../hmodules/components/h-file-chooser/file-chooser.component.html'
        });

    HFileChooserComponent.$inject = [];

    function HFileChooserComponent() {

        var self = this;

        self.viewOnly = self.viewOnly || false;

        self.removeAttachment = function (index) {
            self.data.attachments.splice(index, 1);
        };

        self.classContainer = {'disabled': self.disabled};
        self.classContainer[self.class] = !!self.class;

        self.addAttachments = function (files) {

            if (files && files.length) {

                var notValidTypeMessage = ['<p>' + $filter('translate')('The attached file(s) could not be uploaded:') + '</p>', '<ul>'];
                var notValidSizeMessage = ['<p>' + $filter('translate')('The attached file(s) could not be uploaded:') + '</p>', '<ul>'];
                var showSizeErrorMessage;
                var showTypeErrorMessage;

                for (var i in files) {
                    var file = files[i];
                    var fileType = file.type;

                    var validType = fileType === 'image/jpeg' || fileType === 'image/png' || fileType.indexOf('pdf') > -1;

                    //Max file size: 7MB
                    var validSize = file.size <= 7000000;

                    if (validType && validSize) {
                        file.tmp = true;
                        self.data.attachments.push(file);
                    }

                    if (!validType) {
                        notValidTypeMessage.push('<li>' + file.name + '</li>');
                        showTypeErrorMessage = true;
                    }

                    if (!validSize) {
                        notValidSizeMessage.push('<li>' + file.name + '</li>');
                        showSizeErrorMessage = true;
                    }
                }

                notValidTypeMessage.push('</ul>');
                notValidTypeMessage.push('<p>' + $filter('translate')('You can only attach a file(s) of type pdf, png or jpeg.') + '</p>');

                notValidSizeMessage.push('</ul>');
                notValidSizeMessage.push('<p>' + $filter('translate')('The file(s) exceeds the maximum size of 7MB.') + '</p>');

                if (showTypeErrorMessage) {
                    hAlert(
                        $filter("translate")("Invalid Files"),
                        notValidTypeMessage.join(''),
                        function () {},
                        'rejection-templates-error-alert'
                    );
                } else if (showSizeErrorMessage){
                    hAlert(
                        $filter("translate")("Invalid Files"),
                        notValidSizeMessage.join(''),
                        function () {},
                        'h-file-chooser-error-alert'
                    );
                }
            }
        };
    }
})();